<script lang="ts">
  import { getContext, setContext, onMount, createEventDispatcher, onDestroy } from "svelte";
  import type { ControlValidator } from "./validators";
  import { FormControl } from "./controls";

  const dispatch = createEventDispatcher<{ change: FormControl; submit: FormControl }>();

  // either set name
  export let name: string = null;
  export let validators: ControlValidator[] = [];
  // ... or bind a form
  export let form: FormControl = null;

  const parent = getContext<FormControl>("form");
  if (parent) {
    throw new Error("Forms can not be nested!");
  }

  if (!form) {
    if (!name) throw Error("Form: please set either 'name' or 'form' property");
    form = new FormControl(name);
  }

  validators.forEach((_) => form.addValidator(_));
  form.submitEvent = () => dispatch("submit", form);

  setContext("form", form);
  onMount(() => form.update());

  const { changes, valueChanges } = form;

  $: ctrl = $changes;
  $: dispatch("change", $valueChanges);
</script>

<form
  novalidate
  on:submit={(e) => {
    e.preventDefault();
    ctrl.submit();
  }}
>
  <slot form={ctrl} />
</form>
